import { render, staticRenderFns } from "./AdminCellTimestampReadable.vue?vue&type=template&id=cffe8a70&"
import script from "./AdminCellTimestampReadable.vue?vue&type=script&lang=js&"
export * from "./AdminCellTimestampReadable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports